import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Hero } from '../components/Hero';
import { Intro } from '../components/Intro';
import { Services } from '../components/Services';
import { Process } from '../components/Process';
import { CTA } from '../components/CTA';
import { Contact } from '../components/Contact';
import { FloatingCTA } from '../components/FloatingCTA';
import { ScrollIndicator } from '../components/ScrollIndicator';
import { SEO } from '../components/SEO';
export function Home() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [location]);
  return <main data-id="element-273">
      <SEO title="PP Management & Consulting – Strategische Beratung für Geschäftsführer & Gesellschafter" description="PP Management & Consulting berät Geschäftsführer und Gesellschafter bei GmbH-Gründung, Holding-Strukturierung, Geschäftsführer-Beratung und Nachfolgeplanung. Strategische Unternehmensberatung in Berlin für nachhaltiges Wachstum." canonical="https://ppimpact.com/" jsonLd={{
      '@context': 'https://schema.org',
      '@type': 'ProfessionalService',
      name: 'PP Management & Consulting',
      description: 'Strategische Unternehmensberatung für Geschäftsführer und Gesellschafter. Wir beraten bei GmbH-Gründung, Holding-Strukturierung, Geschäftsführer-Beratung und Nachfolgeplanung.',
      url: 'https://ppimpact.com',
      telephone: '+49-151-14796710',
      email: 'info@ppimpact.com',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Grüner Weg 59A',
        postalCode: '12359',
        addressLocality: 'Berlin',
        addressCountry: 'DE'
      },
      priceRange: '€€€',
      serviceType: ['GmbH-Gründungsberatung', 'Holding-Strukturierung', 'Geschäftsführer-Beratung', 'Nachfolgeplanung', 'Beteiligungsmodelle', 'Haftungsmanagement'],
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Beratungsleistungen',
        itemListElement: [{
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Gründungsberatung',
            description: 'Von der Rechtsformwahl bis zur notariellen Beurkundung. Begleitung des gesamten Gründungsprozesses.'
          }
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Strukturierung',
            description: 'Holding-Strukturen, Beteiligungsmodelle und gesellschaftsrechtliche Optimierung.'
          }
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Geschäftsführer-Beratung',
            description: 'Haftungsmanagement, Vergütungsoptimierung und strategische Positionierung.'
          }
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Nachfolgeplanung',
            description: 'Strukturierte Übergabeprozesse, Bewertung und steueroptimierte Nachfolgeregelungen.'
          }
        }]
      }
    }} data-id="element-274" />
      {/* Fixed Header */}
      <header className="fixed top-0 left-0 right-0 z-40 bg-bg" data-id="element-275">
        <div className="flex items-center justify-between px-3 md:px-6 h-20 md:h-24" data-id="element-276">
          <Link to="/" data-id="element-277">
            <img src="https://cdn.magicpatterns.com/uploads/u58yyudAVGYZM45T7aPn3Z/PP_Logo_Lime.svg" alt="PP Management & Consulting" className="h-16 md:h-20 w-auto p-1.5" data-id="element-278" />
          </Link>
          <FloatingCTA data-id="element-279" />
        </div>
      </header>
      <ScrollIndicator data-id="element-280" />
      <Hero data-id="element-281" />
      <Intro data-id="element-282" />
      <Services data-id="element-283" />
      <Process data-id="element-284" />
      <CTA data-id="element-285" />
      <Contact data-id="element-286" />
    </main>;
}